import type { PxQuestion } from './types';

/**
 * Compact per-answer draft entry — NOT the full `PxQuestion[]` catalog.
 *
 * `Projekt.metadata` is a `varchar(5000)` DB column. The full Fragenkatalog
 * (all questions/answers, largely unchanged boilerplate) easily exceeds that on
 * a real insurer catalog — the write silently truncates in that case, and the
 * truncated JSON then fails to parse back (`safeParse` swallows the error and
 * returns `{}`), so a resumed draft looks empty. Persisting only the filled-in
 * answers keeps the draft small; on resume they're re-applied onto a freshly
 * fetched catalog (see `PxReportAction: 'APPLY_DRAFT'`).
 */
export interface PxDraftAnswer {
    questionKey: string;
    answerUid: string;
    isSelected: boolean;
    comment: string | null;
    quantity: number;
}

/** Collect every answer that has been touched (selected, commented, or quantified). */
export const extractDraftAnswers = (questions: PxQuestion[]): PxDraftAnswer[] => {
    const out: PxDraftAnswer[] = [];
    for (const question of questions) {
        for (const answer of question.answers) {
            if (!answer.isSelected && !answer.comment && !answer.quantity) continue;
            out.push({
                questionKey: question.key,
                answerUid: answer.uid as string,
                isSelected: answer.isSelected,
                comment: answer.comment,
                quantity: answer.quantity,
            });
        }
    }
    return out;
};
